var map = {
	"./anglo-american.png": 53,
	"./ascc.svg": 54,
	"./atentus.png": 55,
	"./bci.png": 56,
	"./cchc.svg": 57,
	"./chilecompra.jpg": 58,
	"./cne.jpg": 59,
	"./codelco.png": 60,
	"./deloitte.png": 61,
	"./ecertchile.png": 62,
	"./energia.jpg": 63,
	"./fcfm.png": 64,
	"./indra.png": 65,
	"./isl.jpg": 66,
	"./ist.jpeg": 67,
	"./lider.svg": 68,
	"./nic.jpeg": 69,
	"./pronto-copec.jpg": 70,
	"./sag.jpg": 71,
	"./sernac.jpg": 72,
	"./sicpa.png": 73,
	"./sicpa.svg": 74,
	"./suseso.jpg": 75,
	"./walmart.jpg": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;